import TranslationProvider from '@/provider/translations.js'
import { client } from '@/services/fetch.js'

export const canDelegateREA = async (compiledPoll, modalBulkActionsPayload) => {
  if (!modalBulkActionsPayload['rea']){
    return null;
  }

  return canDelegate(compiledPoll, modalBulkActionsPayload, 'delegateREA')
}

export const canDelegateRE = async (compiledPoll, modalBulkActionsPayload) => {
  if (!modalBulkActionsPayload['re']){
    return null;
  }

  return canDelegate(compiledPoll, modalBulkActionsPayload, 'delegateRE')
}

const canDelegate = async (compiledPoll, modalBulkActionsPayload, type) => {
  const url = '/custom/default-vr/bulk/can-delegate';
  try{
    const res = await client.post(url, {
      type,
      compiledPoll,
      modalBulkActionsPayload
    }, 'application/json')

    if (res.status === 'ok') {
      return null;
    }else{
      return TranslationProvider.getTrans(res.error)
    }
  }catch (e) {
    return TranslationProvider.getTrans('app.massive_error_delegate_cc')
  }
}
